import { takeLatest, put, all, call } from 'redux-saga/effects';
import { getAllUpcoming, onSuccess, onFailure } from './upcoming.slice';
import { getAllUpComingApi } from './upcoming.utils';
export function* fetchUpcoming({ payload }) {
  try {
    const { data } = yield call(getAllUpComingApi, payload);

    yield put(onSuccess(data));
  } catch (error) {
    yield put(onFailure(error.toString()));
  }
}

export function* onFetchUpcoming() {
  yield takeLatest(getAllUpcoming.toString(), fetchUpcoming);
}

export function* upcomingSagas() {
  yield all([call(onFetchUpcoming)]);
}
